import { render } from "./AIAutopopulateSwitch.vue?vue&type=template&id=3c4ef436&scoped=true"
import script from "./AIAutopopulateSwitch.vue?vue&type=script&lang=js"
export * from "./AIAutopopulateSwitch.vue?vue&type=script&lang=js"

import "./AIAutopopulateSwitch.vue?vue&type=style&index=0&id=3c4ef436&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4ef436"]])

export default __exports__